module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAABGCAMAAACEwFYyAAAAaVBMVEUAAAD/AACqVVW2JCS/QEC/NTXCMzPEMTHBMjXBMjXCNDTDNDTDMzPBMzXCNDTDMzPCNDTDMzPCMzXCMzTCMjTCNDTBMzXCMzTCMjTBNDTCMzXCMzTCMzTBMzTCMzPCMzTCMzTCMzT////7pp0EAAAAIXRSTlMAAgMHCBgZGlZXWFlub3FyqKmqq8XGx8nKy8zNzs/Q0vXncmQvAAAAAWJLR0QiXWVcrAAAAGxJREFUSMft17cBgEAQA0E93nvvv/8mgQq4S4i08RQgAfDK9bKfXUvh4Sk8rLA9AJzRiusNUqsoRqvhNRYNn3Fq+ElOTk5OTk5OTk7+B591o7bR8AqJhkcwg1x3Bgg2qV7993y4+SS5KmPmAjeyb5nia4kIYAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/redCard.png
// module id = AKZp
// module chunks = 79